import React, { useEffect, useRef, useState } from 'react';
import CreateQuestions from '../../../component/EliteGame/CreateQuestions';
import { ELITE_QUIZ_TYPE } from '../../../utils/constants';
import QuestionsList from '../../../component/EliteGame/QuestionsList';
import {
  createQuestion,
  deleteQuestion,
  GetExamModule,
  getQuestionsByQuizType,
  updateQuestion
} from '../../../api/eliteGameApi';
import ViewQuestionModal from '../../../component/EliteGame/ViewQuestionModal';
import { useEliteGames } from '../../../context/EliteGamesContext';
import { errorToast, successToast } from '../../../utils/helper';
import DeletePopup from '../../../component/common/modals/DeletePopup';

const ExamModuleManageQuestions = () => {
  const [refresh, setRefresh] = useState(true);
  const [selectedQuestion, setSelectedQuestion] = useState(null);
  const [page, setPage] = useState(1);

  const [questions, setQuestions] = useState([]);
  const [examModuleData, setExamModuleData] = useState([]);
  const [viewModalOpen, setViewModalOpen] = useState(false);
  const [viewQuestion, setViewQuestion] = useState(null);
  const [refreshFlag, setRefreshFlag] = useState(0);
  const [questionId, setQuestionId] = useState(null);
  const [open, setOpen] = useState(false);
  const formRef = useRef(null);

  const handleView = (question) => {
    console.log('Viewing question:', question);
    setViewQuestion(question);
    setViewModalOpen(true);
  };
  const { setLoading } = useEliteGames();
  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await GetExamModule();
        console.log('Fetched Exam Module data:', data);

        setExamModuleData(
          data?.data?.map((d) => ({
            ...d,
            name: d.title
          })) || []
        );
      } catch (error) {
        console.error('Failed to fetch questions', error);
      }
    };

    fetchData();
  }, []);
  const onSubmit = async (data) => {
    setLoading(true);
    try {
      const formData = {
        ...data,
        quizType: ELITE_QUIZ_TYPE.EXAM_MODULE,
        options: [
          data.optionA,
          data.optionB,
          ...(data.questionType != 2 ? [data.optionC, data.optionD] : [])
        ],
        correctAnswer: data[data.answer.value || data.answer]
      };
      if (selectedQuestion) {
        const response = await updateQuestion(formData, selectedQuestion._id);

        setSelectedQuestion(null);
        successToast('Question updated successfully', response.message);
      } else {
        const response = await createQuestion(formData);
        setRefreshFlag((prev) => prev + 1);
        successToast('Question created successfully', response.message);
      }
      getQuestions(); // Refresh questions list after creating a new question
      setSelectedQuestion({});
      setSelectedQuestion(null);
    } catch (error) {
      console.error('Failed to create question', error);
      errorToast('Failed to create question. Please try again.', error.message);
    } finally {
      setLoading(false);
    }

    setRefresh(!refresh); // Refresh questions list after creating a new question
    setSelectedQuestion(null); // Clear selected question after submission
  };

  const getQuestions = async (filter = {}) => {
    try {
      const data = await getQuestionsByQuizType(ELITE_QUIZ_TYPE.EXAM_MODULE, {
        page,
        limit: 10,
        ...filter
      });
      console.log('Fetched exam questions:', data);
      setQuestions(data || []);
    } catch (error) {
      console.error('Failed to fetch questions', error);
    }
  };
  useEffect(() => {
    getQuestions();
  }, [refresh, page]);

  const handleFilter = (filter) => {
    getQuestions(filter);
    setPage(1);
  };
  const handleEdit = (question) => {
    setSelectedQuestion(question);
    formRef.current?.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  };
  const handleDelete = async () => {
    setLoading(true);
    try {
      // Call API to delete question
      await deleteQuestion(questionId);
      successToast('Question deleted successfully');
      setRefresh(true); // Refresh questions list after deletion
    } catch (error) {
      errorToast('Error deleting question:', error);
    } finally {
      setLoading(false);
    }
    setRefresh(!refresh);
  };
  return (
    <div>
      <div className="bg-white rounded-lg shadow p-6 mx-4">
        <div className="cursor-pointer mb-3 text-[24px] font-bold leading-9 text-shoorah-lightBlack">
          Create and Manage Questions for Exam Module
        </div>
      </div>
      <div ref={formRef}>
        <CreateQuestions
          onSubmit={onSubmit}
          name={'Exam Module'}
          quizType={ELITE_QUIZ_TYPE.EXAM_MODULE}
          dropDownData={examModuleData}
          existingQuestion={selectedQuestion}
          resetTrigger={refreshFlag}
        />
      </div>
      <div className="bg-white rounded-lg shadow p-6 m-4">
        <div className="mb-2">
          <span className="text-2xl font-bold text-black-600">Questions for Exam Module</span>
        </div>
        <hr className="mb-6" />
        <QuestionsList
          quizType={ELITE_QUIZ_TYPE.EXAM_MODULE}
          questions={questions}
          onEdit={handleEdit}
          onFilter={handleFilter}
          page={page}
          dropdowndata={examModuleData}
          setPage={setPage}
          onView={handleView}
          onDelete={(id) => {
            setQuestionId(id);
            setOpen(true);
          }}
        />
        {DeletePopup({
          title: 'Confirm Deletion',
          open,
          setOpen,
          message:
            'Are you sure you want to delete this question? All related data will also be deleted.',
          setDelete: handleDelete
        })}
      </div>
      <ViewQuestionModal
        questions={viewQuestion}
        onClose={() => setViewModalOpen(false)}
        isOpen={viewModalOpen}
      />
    </div>
  );
};

export default ExamModuleManageQuestions;
